<template>
    <div>
        <app-bar :title="product.name"/>

        <v-layout>
            <v-progress-linear
                v-if="overlay"
                absolute
                indeterminate
            ></v-progress-linear>

            <div class="pt-8 pb-12 px-8">
                <div class="pb-10">
                    <v-btn
                        v-if="permitted('admin_club_management')"
                        @click="edit"
                        class="sm mr-5"
                        color="primary"
                    >{{ t('general_action_edit') }}
                    </v-btn>
                    <v-btn
                        v-if="permitted('admin_club_management')"
                        class="sm mr-5"
                        color="primary"
                        outlined
                        @click.prevent="suspend(product)"
                    >
                        {{ product.enabled ? t('general_action_suspend') : t('general_action_unsuspend') }}
                    </v-btn>
                    <confirm-modal
                        v-if="permitted('admin_club_management')"
                        :title="t('general_title_confirm_action')"
                        @agree="del(product)"
                    >
                        <template #default="{ on, attrs }">
                            <v-btn
                                class="sm"
                                color="orange"
                                outlined
                                v-on="on"
                                v-bind="attrs"
                            >{{ t('general_action_delete') }}</v-btn>
                        </template>
                    </confirm-modal>
                </div>
                <div class="float-left mr-10" style="width: 394px; max-width: 394px">
                    <img
                        v-if="product.photoUrl"
                        :src="product.photoUrl"
                        width="150"
                    />
                    <div class="form-subtitle">{{ t('club_product_label_description') }}:</div>
                    <div class="form-subtitle-description" v-html="product.description"></div>
                    <div v-if="product.link" class="form-subtitle">{{ t('club_product_label_link') }}:</div>
                    <div v-if="product.link" class="form-subtitle-description">{{ product.link }}</div>
                </div>
                <div class="float-left" style="max-width: calc(100% - 434px)">
                    <card-unit :items="items()">
                        <template #title>{{ t('club_product_label_id') }}: {{ product.id }}</template>
                    </card-unit>
                </div>
            </div>
        </v-layout>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, onMounted, reactive, toRefs } from '@vue/composition-api'
    import { useI18n } from 'vue-i18n-composable'
    import { useStore } from '@/store'
    import { useRouter } from '@/composition-api'
    import { ClubProduct } from '@/core/models/club-product'
    import ConfirmModal from '@/components/ConfirmModal.vue'
    import CardUnit from '@/components/CardUnit.vue'

    export default defineComponent({
        components: {
            ConfirmModal,
            CardUnit
        },

        setup(props) {
            const store = useStore()
            const router = useRouter()
            const i18n = useI18n()
            const id = router.currentRoute.params['id']

            const state = reactive({
                overlay: true,
            })

            const capture = () => {
                store.dispatch('clubProduct/get', { id: id, payload: {} }).then(() => {
                    state.overlay = false
                })
            }

            const productModel = computed(() => <ClubProduct>store.getters['clubProduct/get'])

            const suspend = (item: ClubProduct) => {
                state.overlay = true
                store.dispatch('clubProduct/update', {
                    id: item.id,
                    payload: { enabled: ! item.enabled }
                }).then(() => {
                    store.dispatch('notify', { color: 'success', message: i18n.t('general_notice_data_updated') })
                    capture()
                })
            }

            const edit = () => router.push({ name: 'club-products.show', params: { id: <any>productModel.value.id } })

            const del = (item: ClubProduct) => {
                state.overlay = true
                store.dispatch('clubProduct/delete', { id: item.id }).then(() => {
                    router.push({ name: 'club-products' })
                })
            }

            const items = () => {
                return [
                    { text: i18n.t('club_product_label_manufacturer'), value: productModel.value.manufacturer || '-' },
                    { text: i18n.t('general_label_creation_date'), value: productModel.value.createdAt.format('DD/MM/YYYY') },
                    { text: i18n.t('general_action_published'), value: productModel.value.enabled ? i18n.t('general_text_yes') : i18n.t('general_text_no') },
                ]
            }

            onMounted(() => {
                capture()
            })

            return {
                capture,
                items,
                product: productModel.value,
                edit,
                del,
                suspend,
                ...useI18n(),
                ...toRefs(state)
            }
        }
    })
</script>
